// import { TopNav } from "./TopNav";
// import { SideNav } from "./SideNav";
// import React, { useState } from "react";

// export const MainLayout = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);

//   return (
//     <div className="min-h-screen bg-gray-50 overflow-x-hidden">
//       <TopNav />
//       <div className="flex">
//         <div
//           className={`
//           fixed inset-y-0 left-0 w-64 bg-gray-800 text-white z-40 transform transition-transform duration-300 ease-in-out
//           ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
//           lg:translate-x-0
//         `}
//         >
//           <SideNav />
//           <button
//             className="lg:hidden absolute top-4 right-4 text-white"
//             onClick={() => setIsSidebarOpen(false)}
//           >
//             ✕
//           </button>
//         </div>

//         {/* Overlay for mobile sidebar */}
//         {isSidebarOpen && (
//           <div
//             className="fixed inset-0 bg-black opacity-50 z-30 lg:hidden"
//             onClick={() => setIsSidebarOpen(false)}
//           />
//         )}

//         {/* Main content area */}
//         <main className="flex-1 p-4 w-full lg:pl-64 pt-16 max-w-full">
//           {/* Mobile menu toggle */}
//           <button
//             className="lg:hidden mb-4 bg-gray-200 p-2 rounded"
//             onClick={() => setIsSidebarOpen(true)}
//           >
//             ☰ Menu
//           </button>

//           <div className="w-full max-w-full overflow-hidden">{children}</div>
//         </main>
//       </div>
//     </div>
//   );
// };

// export default MainLayout;
import { TopNav } from "./TopNav";
import { SideNav } from "./SideNav";
import React, { useState } from "react";
import { Menu, X } from "lucide-react";

export const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 overflow-x-hidden">
      <TopNav />
      <div className="flex">
        <div
          className={`
          fixed inset-y-0 left-0 w-64 bg-gradient-to-b from-slate-800 via-slate-900 to-slate-800 text-white z-40 transform transition-transform duration-300 ease-in-out shadow-2xl
          ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}
          lg:translate-x-0
        `}
        >
          <SideNav />
          <button
            className="lg:hidden absolute top-4 right-4 p-2 hover:bg-white/10 rounded-xl transition-all duration-200 group"
            onClick={() => setIsSidebarOpen(false)}
          >
            <X className="w-5 h-5 text-slate-300 group-hover:text-white transition-colors duration-200" />
          </button>
        </div>

        {/* Overlay for mobile sidebar */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-30 lg:hidden transition-all duration-300"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {/* Main content area */}
        <main className="flex-1 w-full lg:pl-64 pt-16 max-w-full">
          {/* Mobile menu toggle */}
          <button
            className="lg:hidden fixed top-20 left-4 z-20 bg-white hover:bg-slate-50 p-3 rounded-xl shadow-lg border border-slate-200 transition-all duration-200 group"
            onClick={() => setIsSidebarOpen(true)}
          >
            <Menu className="w-5 h-5 text-slate-600 group-hover:text-slate-800 transition-colors duration-200" />
          </button>

          <div className="w-full max-w-full overflow-hidden">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;